module.exports = __webpack_public_path__ + "04_glasses_red.9a32da90.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/04_glasses_red.png
// module id = mnCL
// module chunks = 0